;(function (Wishlist, $) {
    var $wbwishlistBtn = $('.itbremovewhsh');
    var $wishlistCart = $('.cart');
    var $itbwishcount = $('.itbwishcount');
    var numProductTiles = $wishlistCart.length;
    var wishlist = localStorage.getItem('wbwishtems') || [];
    var wishcountall = localStorage.getItem('wbwishtemscount');

    $itbwishcount.html(wishcountall == null ? 0 : wishcountall);

    if (wishlist.length > 0) {
        wishlist = JSON.parse(localStorage.getItem('wbwishtems'));
    }
    var animateWishlist = function (e) {
        $(e).toggleClass('wishactive');
    };
    var updateWishlist = function (self) {
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('wishactive');
        if (isRemove) {
            var removeIndex = wishlist.indexOf(productHandle);
                wishlist.splice(removeIndex, 1);
            var wbwishcountp = localStorage.getItem('wbwishtemscount');
            if(wbwishcountp != null){
                var minus_val = -1;
                var wish_ct = Math.max(parseInt(wbwishcountp) + minus_val, 0);
                localStorage.setItem('wbwishtemscount', wish_ct);
            }
            localStorage.setItem('wbwishtems', JSON.stringify(wishlist));
            if($(self).find("span").length != 0){
                $wbwishlistBtn.html('<span class="wbaddtowish"><svg><use xlink:href="#wish"></use></svg><span class="wishtext">Add wishlist</span></span><span class="itbwishloding wishanimated"><svg><use xlink:href="#refresh"></use></svg> Add wishlist</span><span class="itbwishlblrmv"><svg><use xlink:href="#icon-close"></use></svg><span>Remove wishlist</span></span>');
            }
            $itbwishcount.html(localStorage.getItem('wbwishtemscount'));
        }
        else {
            wishlist.push(productHandle);
            var wbwishcountp = localStorage.getItem('wbwishtemscount');
            if(wbwishcountp == null){
                var plus_val = 1;
                var wish_ct = plus_val;
            }else{
            var plus_val = 1;
            var wish_ct = Math.max(parseInt(wbwishcountp) + plus_val, 0);
        }
            localStorage.setItem('wbwishtemscount',wish_ct);
            localStorage.setItem('wbwishtems', JSON.stringify(wishlist));
            var icon_length = $(self).find("span").length;
            if(icon_length != 0){
                $wbwishlistBtn.html('<span class="wbaddtowish"><svg><use xlink:href="#wish"></use></svg><span class="wishtext">Add wishlist</span></span><span class="itbwishloding wishanimated"><svg><use xlink:href="#refresh"></use></svg> Add wishlist</span><span class="itbwishlblrmv"><svg><use xlink:href="#icon-close"></use></svg><span>Remove wishlist</span></span>');
            }
            var wbwishcountp_value = localStorage.getItem('wbwishtemscount');
            $itbwishcount.html(wbwishcountp_value);
        }
    };
    var activateWishItems = function () {
        $wbwishlistBtn.each(function () {
        var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) > -1) {
                $(this).addClass('wishactive');
                var icon_length = $(this).find("span").length;
                if($(this).hasClass('wishactive')){
                    if(icon_length != 0){
                        $(this).html('<span class="wbaddtowish"><svg><use xlink:href="#wish"></use></svg><span class="wishtext">Add wishlist</span></span><span class="itbwishloding wishanimated"><svg><use xlink:href="#refresh"></use></svg> Add wishlist</span><span class="itbwishlblrmv"><svg><use xlink:href="#icon-close"></use></svg><span>Remove wishlist</span></span>');
                    }
                }else{
                    if(icon_length != 0){
                        $(this).html('<span class="wbaddtowish"><svg><use xlink:href="#wish"></use></svg><span class="wishtext">Add wishlist</span></span><span class="itbwishloding wishanimated"><svg><use xlink:href="#refresh"></use></svg> Add wishlist</span><span class="itbwishlblrmv"><svg><use xlink:href="#icon-close"></use></svg><span>Remove wishlist</span></span>');
                    }
                }
            }
        });
    };
    var displayWishItems = function () {
        $wishlistCart.each(function () {
        var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) === -1) {
                $(this).remove();
                numProductTiles--;
            }
        });
    };
    var loadWishlist = function () {
        if (window.location.href.indexOf('pages/wishlist') > -1) {
        displayWishItems();
            $('.itbwishloader').fadeOut(2000, function () {
                $('.itbwishcover .wishlist-hero').addClass('wishvisible');
                if (numProductTiles == 0) {
                    $('.itbwishempty').addClass('wishvisible');
                    $('.itbwishcover').hide();
                } else {
                    $('.itbwishempty').hide();
                }
            });
        }
    };
    var bindUIActions = function () {
        $wbwishlistBtn.click(function (e) {
            e.preventDefault();
            updateWishlist(this);
            animateWishlist(this);
        });
    };
    Wishlist.init = function () {
        bindUIActions();
        activateWishItems();
        loadWishlist();
    };
    $("#itbcallwish").click(function(){
        var length = localStorage.getItem('wbwishtems').length;
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('wishactive');
        for ( var i=length-1; i>= 0; i--){
        var removeIndex = wishlist.indexOf(productHandle);
        wishlist.splice(removeIndex, 1);
        var wbwishcountp = localStorage.getItem('wbwishtemscount');
            if(wbwishcountp != null){
                var wish_ct = Math.max(parseInt(0), 0);
                localStorage.setItem('wbwishtemscount', wish_ct);
            }
            localStorage.setItem('wbwishtems', JSON.stringify(wishlist));
        }
        location.reload(true);
    });
}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));
function reloadPage(){
    location.reload(true);
}